import { HStack } from "@chakra-ui/react";
import { AppEnvironmentBadge } from "app/AppEnvironmentBadge";
import React from "react";
import { QueryBoundary } from "shared/api/QueryBoundary";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import PageNav from "shared/components/layout/PageNav";
import Logo from "shared/img/logo.svg?react";

export const AppLoggedOutLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <>
    <PageNav position="absolute" right={0} left={0}>
      <HStack>
        <Logo />
        <AppEnvironmentBadge />
      </HStack>
    </PageNav>
    <PageContainer>
      <PageContent isFullHeight={true}>
        <PageBody>
          <QueryBoundary isPage={true}>{children}</QueryBoundary>
        </PageBody>
      </PageContent>
    </PageContainer>
  </>
);
